var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h200v200H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-.138 -.138) scale(.00862)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAIAAAD6XpeDAAAAA3NCSVQICAjb4U/gAAADPklEQVR4nO2dwY7jQAgFN6v9/1/OXPtiCQaendpUHaNJx0mJQbSh/Xq/33+Eyd+nL0B+j/LAKA+M8sAoD4zywCgPjPLAKA+M8sAoD4zywCgPjPLAKA/Mv+4bXq/X+kWc9xTP9a9eT39WhfTvUMHIA6M8MMoD0855J5P+l0nO2MqF3XWuvu9Tv4ORB0Z5YJQHZpTzTiY5Y7JmhUlOSlzzVq+skQdGeWCUB2Yt520x2ee8+pvKOol91DRGHhjlgVEemI/LeVf5pnLvbZLDKHnuxMgDozwwygOzlvO29uu6dVg3/1U+N7FOAiMPjPLAKA/MKOclaqPJPmSltpvk0co134mRB0Z5YJQHpp3z0nXMU+t3898nnNlm5IFRHhjlgRnN51X2A7fo1nDd66nksPQ9RefzvgjlgVEemFGdd/X/vdtjucXWXuWdtd1kTSMPjPLAKA9MpM7rrnPFnfuHW/cRKzifJ8ojozwwkZn0rT7JyuuTPclu3u1+x0R/6YmRB0Z5YJQHJjKftzUP1509v2KyVzmZi09j5IFRHhjlgXlt9eUn9jkTtVGCp85IM/LAKA+M8sCszSps1WTda0jUYVu9qelzzow8MMoDozwwa88SSvTlVz5rcg7nZIZ9q59lgpEHRnlglAdmbVbh6m8q7+32vFTy0MlTPZbp2XYjD4zywCgPTPt+XmnRG/f9tq4/PbeeuA9q5IFRHhjlgVnLeYk+/sk1nGydT52Y4XNW4UtRHhjlgYk8VyF9jvNkL7RCuvat7MdWMPLAKA+M8sDE67ytfLO1ZzjZd01gzvtSlAdGeWDiz8/7n+q5rV7TLYw8MMoDozwwa7MKE9Lndiaek/4Jc/FGHhjlgVEemFGdd2eu+oT90sqak8/tYuSBUR4Y5YGJnDF9xZ3PDzqZPPPoap0Kib6VEyMPjPLAKA9M5IzpLbr3CLdqwUTf6Yl1niiPjPLAfFzOu7Mn5c7arluDVjDywCgPjPLAxPs20+ufOWNr3nyL9LnbRh4Y5YFRHpi1ZwlN2Oof2drP7PLUc/WMPDDKA6M8MJHzNuUejDwwygOjPDDKA6M8MMoDozwwygOjPDDKA6M8MMoDozwwygOjPDA/umosH7j8etUAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr2);
export default __webpack_public_path__ + "static/media/qr-2.3215fb3f9ed4b704e3dd283c6a002ed9.svg";
export { ForwardRef as ReactComponent };